import handleQueryError from '../../../../util/Common/Error/Handler/handleQueryError';
import safetyDefaultAPI from '../../api';

const postDamageReport = async ({ postData }) => {
  try {
    const response = await safetyDefaultAPI.post('damage-report', postData);
    return response;
  } catch (error) {
    throw new Error(handleQueryError({ error }));
  }
};

export default postDamageReport;
